import { ActionCreator, Dispatch } from "redux";
import ActionTypes from "./ActionTypes";

export const setBreadcrumbs: ActionCreator<any> = (data) => async (
  dispatch: Dispatch
) => {
  // TODO set theme
  dispatch({ type: ActionTypes.SET_BREADCRUMBS, payload: { data } });
};

export const navigateBreadcrumbs: ActionCreator<any> = (index) => async (
  dispatch: Dispatch
) => {
  // TODO set theme
  dispatch({ type: ActionTypes.NAVIGATE_BREADCRUMBS, payload: { index } });
};
